import React from "react"
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import mixin from '../utils/mixin'
import WeatherIcon from "./weather-icon";

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Box from '@material-ui/core/Box'
import AppBar from '@material-ui/core/AppBar';

const useStyles = makeStyles((theme) => ({
  point: {
    flexGrow: 1,
    fontWeight: 600,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  day: {
    paddingBottom: theme.spacing(5),
  },
  content: {
    //paddingTop: theme.spacing(2),
    //paddingBottom: theme.spacing(2),
    borderBottom: `1px solid rgb(200, 200, 200)`,
    margin: 0,
  },
  defaultHeader: {
    marginBottom: `1px`,
    borderBottom: `1px solid rgb(158, 158, 158)`,
    backgroundColor: '#fff',
    marginLeft: `0.4px`,
  },
  header: {
    //paddingTop: theme.spacing(2),
    marginBottom: `4px`,
    borderBottom: `1px solid rgb(158, 158, 158)`,
    display: `flex`,
    position: `-webkit-fixed`,
    position: `fixed`,
    top: `0px`,
    backgroundColor: '#fff',
    zIndex: 100,
    marginLeft: `0.4px`,
    [theme.breakpoints.down('sm')]: {
      width: `93.6%`,
    },
    [theme.breakpoints.up('md')]: {
      width: 1240,
    },
  },
  itemOuter: {
    height: `4.2rem`,
    verticalAlign: `middle`,
    //display: `table`,
  },
  itemInner: {
    display: `flex`,
    margin: `auto`,
    borderRight: `1px solid rgb(200, 200, 200)`,
    height: `100%`,
  },
  itemInnerWeather: {
    height: `100%`,
  },
  forcast: {
    backgroundColor: `#fff`
  },
  spend: {
    backgroundColor: `rgb(222, 222, 222)`
  },
  formControl: {
    margin: theme.spacing(1),
    width: `95%`,
  },
  p: {
    margin: `auto !important`,
  },
  arrow: {
    margin: `auto !important`,
    fontSize: `1.2rem`,
  }
}));

export const NumericalForcast = ({ isException, data, updateParams, currentParams, isFirstSortTermForcast  }) => {
  const classes = useStyles();

  const headerItem1 = ["時間", "天気", "風向", "風速(m/s)", "波向", "波高(m)", "周期(s)"];
  const headerItem2 = ["時間", "天気", "風向", "風速(m/s)", "波向", "波高(m)", "周期(s)"];
  const headerItem3 = ["時間", "天気", "地上<br />風向", "地上<br />風速<br />(m/s)", "975hpa<br />風向", "975hpa<br />風速<br />(m/s)"];
  const headerItem4 = ["時間", "天気", "波向", "波高(m)", "周期(s)"];

  const headerExceptionItem1 = ["時間", "天気", "風向", "風速<br />(m/s)",];

  const [type, setType] = React.useState(1);
  const [viewList, setViewList] = React.useState([]);

  const params = [...new URLSearchParams(currentParams).entries()].reduce((obj, e) => ({...obj, [e[0]]: e[1]}), {});

  React.useEffect(() => {
    const createViewByType = (key, value) => {
      if (key === "dir") {
        return(
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.arrow} variant="inherit" component="p" style={mixin.formatDirectionArrowStyle(value)}>
                ↓
              </Typography>
              <Typography className={classes.p} variant="inherit" component="p">
                {mixin.formatDirection(value)}
              </Typography>
            </Box>
          </Grid>
        )
      }
      else if (key === "w") {
        return(
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.p} variant="inherit" component="p" style={mixin.colorWindPower(value)}>
                {value}
              </Typography>
            </Box>
          </Grid>
        )
      }
      else if (key === "h") {
        return(
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.p} variant="inherit" component="p" style={mixin.colorWaveHeight(value)}>
                {value}
              </Typography>
            </Box>
          </Grid>
        )
      }
      else if (key === "p") {
        return(
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.p} variant="inherit" component="p" style={mixin.colorWavePerid(value)}>
                {value}
              </Typography>
            </Box>
          </Grid>
        )
      }
      else if (key === "date"){
        return (
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.p} variant="inherit" component="p">
                {mixin.formatHour(value)}
              </Typography>
            </Box>
          </Grid>
        )
      }
      else if (key === "weather") {
        return (
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              {(data.loc.msm[value] && data.loc.msm[value]["-wx"] !== "n/a" && !isSpend(value)) ? (
                <WeatherIcon src={`weather/${data.loc.msm[value]["-wx"]}.png`} />
              ) : (
                <Typography className={classes.p} variant="inherit" component="p">
                  -
                </Typography>
              )}
            </Box>
          </Grid>
        )
      }
      else {
        return (
          <Grid item xs className={classes.itemOuter}>
            <Box className={classes.itemInner}>
              <Typography className={classes.p} variant="inherit" component="p">
                {value}
              </Typography>
            </Box>
          </Grid>
        )
      }
    }

    const isSpend = (date) => {
      const c = new Date();
      const current = new Date(c.getFullYear(), c.getMonth(), c.getDate(), c.getHours(), 0, 0);
      return current > mixin.getDateByString(date);
    }

    let currentType = type;
    let currentHeaderItem = headerItem1;

    if (isException && params.datatype === "gfs0p25") {
      currentType = 1;
      currentHeaderItem = headerExceptionItem1;
    }
    else if (isException && params.datatype === "jma-gwm0p50") {
      currentType = 2;
      currentHeaderItem = headerItem4;
    }
    else if (params.datatype === "mww30p50" && params.int === "3") {
      currentType = 2;
      currentHeaderItem = headerItem2;
    }
    else if (params.datatype === "jma-msm0p05") {
      currentType = 3;
      currentHeaderItem = headerItem3;
    }
    else if (params.datatype === "jma-cwm0p05") {
      currentType = 4;
      currentHeaderItem = headerItem4;
    }

    let pointByDay = [];
    let isHeader = false;

    for( var item of data.loc.main.pred ) {
      const day = mixin.getDayKey(item["-date"])
      const headerView = <Grid
                     container
                     spacing={1}
                     align="center"
                     alignItems="flex-start"
                     className={classes.header}
                     key={`header-${day}`}
                    >
                        {currentHeaderItem.map((v, i) => (
                          <Grid className={classes.itemOuter} item xs >
                            <Box className={classes.itemInner}>
                              <Typography className={classes.p} variant="inherit" component="p" dangerouslySetInnerHTML={{__html: v}} />
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
      const defaultHeaderView = <Grid
                     container
                     spacing={1}
                     align="center"
                     alignItems="flex-start"
                     className={classes.defaultHeader}
                     key={`header-${day}`}
                    >
                        {currentHeaderItem.map((v, i) => (
                          <Grid className={classes.itemOuter} item xs >
                            <Box className={classes.itemInner}>
                              <Typography className={classes.p} variant="inherit" component="p" dangerouslySetInnerHTML={{__html: v}} />
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
      let view = <Grid
                     spacing={1}
                     container
                     direction="row"
                     align="center"
                     alignItems="center"
                     className={clsx(classes.content, isSpend(item["-date"]) ? classes.spend : classes.forcast)}
                     key={`content-${item["-date"]}`}
                    >
                      { createViewByType("date", item["-date"]) }
                      { createViewByType("weather", item["-date"]) }

                      {/* mwwのときの風 */}
                      { (currentType <= 2 && isException === false) && createViewByType("dir", item["wind"]["-dir"]) }
                      { (currentType <= 2 && isException === false) && createViewByType("w", item["wind"]["-spd"]) }

                      {/* 風予報以外のときの波 */}
                      { ((currentType <= 2 && isException === false) || currentType === 4) && createViewByType("dir", item["pwave"]["-dir"]) }
                      { ((currentType <= 2 && isException === false) || currentType === 4) && createViewByType("h", item["pwave"]["-ht"]) }
                      { ((currentType <= 2 && isException === false) || currentType === 4) && createViewByType("p", item["pwave"]["-pd"]) }

                      {/* mwwの例外ポイントのときの風gfs */}
                      { (currentType === 1 && isException === true) && createViewByType("dir", item["-wd"]) }
                      { (currentType === 1 && isException === true) && createViewByType("w", item["-ws"]) }

                      {/* mwwの例外ポイントのときの波 gwm */}
                      { (currentType === 2 && isException === true) && createViewByType("dir", item["pwave"]["-dir"]) }
                      { (currentType === 2 && isException === true) && createViewByType("h", item["pwave"]["-ht"]) }
                      { (currentType === 2 && isException === true) && createViewByType("p", item["pwave"]["-pd"]) }

                      {/* MSM 風予報 */}
                      { currentType === 3 && createViewByType("dir", item["-wd"], 3) }
                      { currentType === 3 && createViewByType("w", item["-ws"]) }
                      { currentType === 3 && createViewByType("dir", item["-wd975"], 3) }
                      { currentType === 3 && createViewByType("w", item["-ws975"])}
                    </Grid>
      if (day in pointByDay) {
        pointByDay[day].push(view);
      }
      else {
        if (isHeader === false) {
          pointByDay[day] = [defaultHeaderView, headerView, view];
          isHeader = true;
        }
        else {
          pointByDay[day] = [view];
        }
      }
    }
    setViewList(pointByDay);
    setType(currentType);
  }, []);

  const handleChange = (event) => {

    if (event.target.value === 1) {
      if (isException) {
        updateParams(`&datatype=gfs0p25`);
      }
      else {
        updateParams(`&datatype=mww30p50&int=1`);
      }
    }
    if (event.target.value === 2) {
      if (isException) {
        updateParams(`&datatype=jma-gwm0p50`);
      }
      else {
        updateParams(`&datatype=mww30p50&int=3`);
      }
    }
    else if (event.target.value === 3) {
      updateParams(`&datatype=jma-msm0p05`);
    }
    else if (event.target.value === 4) {
      updateParams(`&datatype=jma-cwm0p05`);
    }
    setType(event.target.value);
  };

  const point = Object.keys(viewList).map((key, i) => {
    return(
      <React.Fragment key={`point-${i}`}>
        <div className={classes.day}>
          <Typography variant="inherit" component="p">{mixin.getDayStr(key)}</Typography>
          <Divider />
          {viewList[key]}
        </div>
      </React.Fragment>
    );
  });
  return (
    <React.Fragment>
      <div id="point" className={classes.point}>
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
        >
          <Grid item xs={6} sm={2} className={classes.buttonArea}>
            <FormControl className={classes.formControl}>
              <InputLabel id="demo-simple-select-helper-label">予報タイプ</InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={type}
                onChange={handleChange}
              >
                { isFirstSortTermForcast && <MenuItem value={3}>短期 - 風予報</MenuItem> }
                { isFirstSortTermForcast && <MenuItem value={4}>短期 - 波予報</MenuItem> }
                <MenuItem value={1}>{isException ? "週間風予報" : "週間予報 - 1時間毎"}</MenuItem>
                <MenuItem value={2}>{isException ? "週間波予報" : "週間予報 - 3時間毎"}</MenuItem>
                { !isFirstSortTermForcast && <MenuItem value={3}>短期 - 風予報</MenuItem> }
                { !isFirstSortTermForcast && <MenuItem value={4}>短期 - 波予報</MenuItem> }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {point}
      </div>
    </React.Fragment>
  );
}

export default NumericalForcast;